import { render, staticRenderFns } from "./superiorTeam.vue?vue&type=template&id=8930a332&scoped=true"
import script from "./superiorTeam.vue?vue&type=script&lang=js"
export * from "./superiorTeam.vue?vue&type=script&lang=js"
import style0 from "./superiorTeam.vue?vue&type=style&index=0&id=8930a332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8930a332",
  null
  
)

export default component.exports